/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard': {
    width: 17,
    height: 17,
    viewBox: '0 0 17 17',
    data: '<g _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M1.547 12.108a.517.517 0 0 0-.508.51v2.553c0 .273.23.478.508.478h2.461c.277 0 .51-.205.51-.478v-2.553a.51.51 0 0 0-.5-.51H1.546zM7.308 7.858a.517.517 0 0 0-.508.51v6.803c0 .273.23.478.508.478h2.22c.276 0 .51-.205.51-.478V8.368a.518.518 0 0 0-.51-.51h-2.22zM12.953.774a.517.517 0 0 0-.508.51V15.17c0 .273.23.478.508.478h2.278c.276 0 .509-.205.509-.478V1.284a.518.518 0 0 0-.51-.51h-2.277z" _stroke="#234357"/><path pid="1" d="M8.211 1.488L.5 8.5M5.03 1.48h3.24v3.187" _stroke="#008AFF"/></g>'
  }
})
